import * as CoisflipService from '@/services/apis/coinsflip'
const state = {
}

const actions = {
    async getGameConfig({ }) {
        try {
            const res = await CoisflipService.getGameConfig()
            return res.data
        } catch (err) {
            if(err.message){ throw JSON.parse(err.message) }
        }
    },
    async updateGameConfig({ }, data) {
        try {
            const res = await CoisflipService.updateGameConfig(data)
            return res.data
        } catch (err) {
            if(err.message){ throw JSON.parse(err.message) }
        }
    },
    async getUserReport({ }, params) {
        try {
            let text = ""
            for (let i in params) {
                text = text ? `${text}&${i}=${params[i]}` : `${i}=${params[i]}`
            }
            const res = await CoisflipService.getUserReport(text)
            return res.data
        } catch (err) {
            if(err.message){ throw JSON.parse(err.message) }
        }
    },
    async getUserDetailReport({ }, params) {
        try {
            let text = ""
            for (let i in params) {
                text = text ? `${text}&${i}=${params[i]}` : `${i}=${params[i]}`
            }
            const res = await CoisflipService.getUserDetailReport(text)
            return res.data
        } catch (err) {
            if(err.message){ throw JSON.parse(err.message) }
        }
    },

}

export default {
    state,
    actions,
}
